import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { setActiveTour } from '@/components/tour/activeTour';
import { RESINSMART_OVERVIEW } from '@/demo/tours/resinsmartOverview';
import type { TourDefinition } from '@/components/tour/tour.types';
import { isDemoMode } from '@/demo/demoState';
import { trackDemoEvent } from '@/demo/tracking';

interface DemoPageProps {
  isEmbed?: boolean;
}

/** Seeded tours. Later these come from /gateway/demo/public/{slug}. */
const TOURS: Record<string, TourDefinition> = {
  [RESINSMART_OVERVIEW.slug]: RESINSMART_OVERVIEW,
  test: RESINSMART_OVERVIEW,
};

/**
 * Launches a tour by slug. Rendering stops here — TourController is mounted above the
 * routes and navigates to the first step itself.
 */
const DemoPage: React.FC<DemoPageProps> = () => {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    const tour = TOURS[slug ?? ''] ?? RESINSMART_OVERVIEW;
    console.info(`[demo] starting tour "${tour.slug}" (${tour.steps.length} steps)`);
    if (isDemoMode()) trackDemoEvent('tour_started');
    setActiveTour(tour);
  }, [slug]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-rs-off-white/60">Loading demo…</div>
    </div>
  );
};

export default DemoPage;
